import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CartService } from 'src/app/services/cart.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-product-note',
    templateUrl: './product-note.component.html',
    styleUrls: ['./product-note.component.scss'],
    standalone: true,
    imports: [MatIconModule, MatDialogModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatInputModule, MatButtonModule, TranslateModule]
})
export class ProductNoteComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private cartService: CartService,
    private dialogRef: MatDialogRef<ProductNoteComponent>
  ) { }

  public noteForm = new UntypedFormGroup({
    note: new UntypedFormControl('', [Validators.required])
  });

  ngOnInit(): void {
    if (this.data) {
      this.noteForm.patchValue({ note: this.data.comment });
    }
  }

  public async onAddingNote(): Promise<void> {
    if (this.data.item_id) {
      const response = await this.cartService.onHandlingProductNote({
        itemId: this.data.item_id ?? this.data.id,
        comment: this.noteForm.get('note')?.value
      });
      this.dialogRef.close(response);
    } else {
      const response = {
        data: {
          item: {
            comment: this.noteForm.get('note')?.value
          }
        }
      };
      this.dialogRef.close(response);
    }
  }

}
